
/*global define*/

define('services/keepAliveServices',[
    'app',
    'jquery',
    //'underscore',
    'backbone'
], function(app, $, Backbone) {
    'use strict';

  var keepAliveService  = function() {
      var that = this,
        errorCounter = 0,
        successCallback = function() {
          errorCounter = 0;
        },
        errorCallback = function(objAJAXRequest, exception) {
          errorCounter++;

          if (errorCounter === 3) {
            app.eventAggregator.trigger("connection:interrupted", that);
            clearInterval(that.caller);
            that.caller = null;
          }
        },
        callerObj = {
          type: "GET",
          cache: false,
          url: "/assets/js/keepAlive.js",
          success: successCallback,
          error: errorCallback
        },

        keepAliveCall = function() {
          var r = new XMLHttpRequest();
          r.open(callerObj.type, callerObj.url, true);
          r.onreadystatechange = function() {
            if (r.readyState === 4) {
              if (r.status !== 200) {
                callerObj.error.call();
              } else {
                callerObj.success.call();
              }
            }
          };
          r.send();
        };

      that.caller = setInterval(keepAliveCall, 20000);
    };


    return keepAliveService;
});